import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BalancedeusarioComponent } from './balancedeusario.component';
import { AuthGuard } from 'app/shared/auth/auth-guard.service';


const routes: Routes = [
  {
    path: '',
     component: BalancedeusarioComponent,
    data: {
      title: 'User'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BalancedeUsarioRoutingModule { }